import { FDIcon } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';

export const HideButton = ({ onClick, loading, disabled }) => {
  return (
    <IconButton
      size="medium"
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      variant="outlined"
      color="error"
    >
      <FDIcon icon="visibilityOff" color="error" />
    </IconButton>
  );
};


HideButton.defaultProps = {
  loading: false,
  disabled: false,
};

HideButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};
